class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    console.log('open');
    var itemlen = $('.cart-item').length;
    console.log('itemlen',itemlen);
    var getitemlocal = localStorage.getItem('timercount');
    $('.upcart_announcement').hide();
    if(getitemlocal != 'hide'){
      $('.upcart_announcement').show();
      if ($('#timer-countdown').length) {
      function countdown( elementName, minutes, seconds )
          {
              var element, endTime, hours, mins, msLeft, time;
              function twoDigits( n )
              {
                  return (n <= 9 ? "0" + n : n);
              }
              function updateTimer()
              {
                  msLeft = endTime - (+new Date);
                  if ( msLeft < 1000 ) {
                      element.innerHTML = "Time is up!";
                      $('.upcart_announcement').hide();
                      localStorage.setItem('timercount', 'hide');
                  } else {
                      time = new Date( msLeft );
                      hours = time.getUTCHours();
                      mins = time.getUTCMinutes();
                      element.innerHTML = (hours ? hours + ':' + twoDigits( mins ) : mins) + ':' + twoDigits( time.getUTCSeconds() );
                      setTimeout( updateTimer, time.getUTCMilliseconds() + 500 );
                  }
              }
              element = document.getElementById( elementName );
              endTime = (+new Date) + 1000 * (60*minutes + seconds) + 500;
              updateTimer();
          }
          countdown( "timer-countdown", 5, 0 );
      }
    }

    // packaging and garantee code
    // var getupsell = localStorage.getItem('upsellId');
    // console.log(getupsell,'getupsell');
    // $('input[data-product-id="'+getupsell+' "]').prop('checked', true);
    // setTimeout(function(){
    //   console.log('******');
    //   if(getupsell == 44874618208415){
    //     console.log('package');
    //     var checkedValue = 44874618208415;
    //     var uncheckedValue = 44874616995999;
    //     $('input[data-product-id="44874618208415"]').prop('checked', true);
    //     $('input[data-product-id="44874616995999"]').prop('checked', false);
    //   }else{
    //     console.log('gift');
    //     var checkedValue = 44874616995999;
    //     var uncheckedValue = 44874618208415;
    //     $('input[data-product-id="44874618208415"]').prop('checked', false);
    //     $('input[data-product-id="44874616995999"]').prop('checked', true);
    //   }
    //   // var checkedValue = $('input[name="selected-product"]:checked').attr('data-product-id');
    //   // var uncheckedValue = $('input[name="selected-product"]:not(:checked)').attr('data-product-id');
    //   console.log(checkedValue,'checkedValue');
    // if(itemlen == 1){
    //   localStorage.setItem('upsellId',checkedValue);
    // }
    //   var matchFound = false;
    //   setTimeout(function(){
    //     $("cart-remove-button").each(function() {
    //       var cartID = $(this).attr('data-product-id');
    //       console.log(cartID,'cartID');
    //       if (checkedValue == cartID) {
    //           matchFound = true; 
    //           return false; 
    //       }
    //     });
    //     if (matchFound) {
    //         console.log("Match found!");
    //     } else {
    //         console.log("No match found!");
    //       addItem(checkedValue, 1);
    //       function addItem(productId, proQtyValue) {
    //       var variantId = productId;
    //       var qty = proQtyValue;
        
    //       let formData = {
    //         items: [
    //           {
    //             id: variantId,
    //             quantity: qty,
    //           },
    //         ],
    //       };
          
    //       fetch(window.Shopify.routes.root + "cart/add.js", {
    //         method: "POST",
    //         headers: {
    //           "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify(formData),
    //       })
    //         .then((response) => {
    //           return response.json();
    //         })
    //         .then(function (response) {
    //           console.log('data',response);
    //            var uncheckedValue = $('input[name="selected-product"]:not(:checked)').attr('data-product-id');
    //            function removeItem() {
    //               let variantId = uncheckedValue;
    //               console.log('remove product',variantId);
    //               fetch("/cart/change.js", {
    //                 method: "POST",
    //                 headers: {
    //                   "Content-Type": "application/json",
    //                 },
    //                 body: JSON.stringify({
    //                   id: uncheckedValue,
    //                   quantity: 0,
    //                 }),
    //               })
    //                 .then((response) => {
    //                   response.json();
    //                 })
    //                 .then((data) => {
    //                   console.log('remove data item',data);
    //                    $("cart-drawer-items").load(location.href + " cart-drawer-items>*", "");
    //                 })
    //                 .catch((error) => {
    //                   console.error("Error: ", error);
    //                 });
    //             }
    //           removeItem();
    //           $("cart-drawer-items").load(location.href + " cart-drawer-items>*", "");
    //           $(".cart-drawer__footer").load(location.href + " .cart-drawer__footer>*", "");
    //           $(".header__icon--cart").load(location.href + " .header__icon--cart>*", "");
    //         })
    //         .catch((error) => {
    //           console.error("Error:", error);
    //         });
    //     }
    //     }
        
    //   }, 500);
    // }, 500);

      // ===Guarantee

      // var checked_Value = $('.Guarantee_btn_check').attr('data-id');
      // setTimeout(function(){
      // var match_Found = false;
      // $("cart-remove-button").each(function() {
      //         var CartID = $(this).attr('data-product-id');
      //         console.log(CartID,'CartID');
      //         if (checked_Value == CartID) {
      //             match_Found = true; 
      //             return false; 
      //         }
      //       });
    
      // if (match_Found) {
      //     console.log("Match found...!");
      // } 
      // else {
      //    console.log("no Match found...!",this);
      //   $('.Guarantee_btn_check').trigger('click');
      // }
      //   }, 500);
    // ==
    // packaging and garantee code ends
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
